import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";

export const ToastContext = React.createContext(undefined);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = (message, type = "info") => {
    console.log(type, message);
    setToast({ message, type });
  };

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => {
        setToast(null);
      }, toast.duration || 5000);

      return () => clearTimeout(timer);
    }
  }, [toast]);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            padding: "16px 24px",
            borderRadius: "8px",
            backgroundColor: getToastBackgroundColor(toast.type),
            color: "#fff",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            zIndex: 9999,
            maxWidth: "400px",
            animation: "slideIn 0.3s ease-out",
          }}
        >
          <span style={{ flex: 1 }}>{toast.message}</span>
          <button
            onClick={() => setToast(null)}
            style={{
              background: "none",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FiX size={16} />
          </button>
        </div>
      )}
    </ToastContext.Provider>
  );
};

const getToastBackgroundColor = (type) => {
  switch (type) {
    case "success":
      return "#4CAF50";
    case "error":
      return "#f44336";
    case "warning":
      return "#ff9800";
    case "info":
    default:
      return "#2196F3";
  }
};

export const useToast = () => {
  const context = React.useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
